import { eventDetailKeys } from '@/features/events/useEventDetail';
import { dashboardKeys, followingFeedKeys, nearbyFeedKeys } from '@/features/events/feed/feedQuery';
import { citywideEventKeys } from '@/features/events/feed/useCitywideEvents';
import type { QueryClient } from '@tanstack/react-query';

export async function invalidateEventQueries(
  queryClient: QueryClient,
  eventID: string,
  feedRefetchType: 'active' | 'inactive' = 'active'
) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: eventDetailKeys.byId(eventID) }),
    queryClient.invalidateQueries({ queryKey: nearbyFeedKeys.all, refetchType: feedRefetchType }),
    queryClient.invalidateQueries({ queryKey: followingFeedKeys.all, refetchType: feedRefetchType }),
    queryClient.invalidateQueries({ queryKey: citywideEventKeys.all, refetchType: feedRefetchType }),
    queryClient.invalidateQueries({ queryKey: dashboardKeys.current() }),
  ]);
}
